import { Injectable } from '@angular/core';
import { Constants } from "./../models/constants";

/*
  Generated class for the PermissionsService provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable({ providedIn: 'root' })
export class PermissionsService {

  constructor(
  ) {
    
  }

  locationPermissionStatus(resultCallback: (status: PermissionStatus) => void) {
    resultCallback(PermissionStatus.Unknown);
  }

  

  requestLocationPermission() {
    
  }

  requestCalendarPermission() {
    
  }

}

export enum PermissionStatus {
  Unknown,
  Granted,
  Rejected
}
